<template>
    <div class="linkFieldModel" v-if="isShow" style="height: auto;">
        <!-- 关联模型 -->
        <el-form-item label="关联模型">
            <TreeSelect
                ref="treeSelect"
                :sourceOptions="dataTable"
                :multiple="false"
                :flat="false"
                :disableBranchNodes="true"
                :valueConsistsOf="valueConsistsOf"
                @treeSelectChoose="handelChangeForm"
            />
        </el-form-item>
        <!-- 关联列表模型显示表头 -->
        <el-form-item label="关联列表模型显示表头" v-if="fieldList">
            <el-select v-model="field.options.config.form.selectTableHeaderFieldsArray" placeholder="请选择" multiple @change="changeSelectTableHeaderFields">
                <el-option
                    v-for="item in fieldList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
            </el-select>
        </el-form-item>
        <!-- 关联字段 -->
        <el-form-item label="关联字段" v-if="fieldList">
            <el-select v-model="selectFields" placeholder="请选择" multiple>
                <el-option
                    v-for="item in fieldList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
            </el-select>
        </el-form-item>
        <el-form-item class="def-item" label="默认筛选值">
            <!-- ext2用在关联数据的下拉类型字段的筛选条件这里，1为固定模式 2位自由模式 -->
            <el-radio-group v-if="field.type === 'link'"  v-model="field.options.ext3" size="mini" >
                <el-tooltip content="固定模式：使用态下在选择关联数据时固定使用设置的默认条件" placement="top">
                    <el-radio label="1">固定模式</el-radio>
                 </el-tooltip>
                <el-tooltip content="自由模式：使用态下第一次弹出选择关联数据时使用设置的默认条件，再次进行筛选时会去掉设置的默认条件，查出所有满足条件的数据" placement="top">
                    <el-radio label="2">自由模式</el-radio>
                </el-tooltip>
            </el-radio-group>
           <div class="def-search" v-if="fieldList&&fieldList.length>0">
                <el-button type="primary" @click="configSearch">配置默认搜索条件</el-button>
           </div>
           <div class="link-config" v-if="linkConfigArr&&linkConfigArr.length>0">
                <div class="link-config-label">
                    关联数据筛选设置
                </div>
                <div class="link-config-content">
                    <div class="link-config-content-item" v-for="(item,index) in linkConfigArr" :key="index">
                         <el-checkbox v-model="item.linkConfigState" @change="changeLinkConfig(item)"></el-checkbox>
                         选择 "{{item.name}}" 字段后 "{{field.name}}" 只出现关联该 "{{item.name}}" 的数据
                    </div>
                </div>
           </div>
<!--           <div class="def-label"  label-width="100px" v-for="filt in filtFields" :key="filt.id">
                <div class="def-tit">{{filt.name}}</div>
                <el-select :ref="filt.id" :key="loadTimer" v-model="defFilt[filt.id].conditionValue" class="def-select" placeholder="请选择" clearable @change="handleChangeSelect" @clear="handleClearSelect(filt)">
                    <el-option
                        v-for="item in filt.options.config.options"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value"
                    />
                </el-select>
            </div> -->
        </el-form-item>
        <!-- 侧滑 -->
        <div class="bi-content-other">
            <el-drawer
              :visible.sync="isShowSearchSetting"
              title="配置默认筛选值"
              :direction="direction"
              size="20vw"
                >
                 <div class="search-field" style="height: 100%;">
                     <SearchCondition
                         ref="searchConditon"
                         :key="searchLoadTimer"
                         :isShowLeftModel="false"
                         :conditionFields="searchFieldList"
                         :allFields="allFields"
                         :class="'search-field-box'"
                         :isHideSearch="true"
                         :style="'height:82vh;overflow:auto;'"
                         >
                     </SearchCondition>
                 </div>
                 <div class="opt" style="position: fixed;bottom: 20px;text-align: center;left: 7vw;">
                     <el-button @click="isShowSearchSetting=false">取消</el-button>
                     <el-button @click="resetSearchConditon">重置</el-button>
                     <el-button type="success" @click="subSetField">确定</el-button>
                 </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
    import { isEmpty, cloneDeep } from 'lodash';
    import TreeSelect from '@/components/TreeSelect';
    import { getFormConfig, getApplicationModelTreeList, getFormConfigFromStore, getApplicationModelTreeListFromStore } from '@/data-model';
    export default {
        components: {
            TreeSelect
        },
        data () {
            return {
                valueConsistsOf: 'LEAF_PRIORITY',
                isShow: false,
                dataTable: [],
                fieldList: undefined,
                searchFieldList: undefined,
                selectFields2: [],
                filtFields: [],
                defFilt: {},
                loadTimer: '',
                searchLoadTimer: '',
                direction: 'ltr',
                isShowSearchSetting: false,
                linkConfigArr: []
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            channelFlag: { // 外部传入的渠道标识，默认是客户使用，us客户，cs客服
                type: String
            },
            appId: { // 外部传入的渠道标识，所属应用（客服系统过来用）
                type: String
            },
            allFields: {
                type: Array
            }
        },
        computed: {
            selectFields: {
                get () {
                    if (isEmpty(this.field.options.config.form.selectFormFields)) {
                        return [];
                    }
                    return this.field.options.config.form.selectFormFields.split(',');
                },
                set (newVal, oldVal) {
                    this.field.options.config.form.selectFormFields = newVal.join(',');
                }
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                this.isShow = false;
                if (this.channelFlag === 'CS') {
                    let modelTree = await getApplicationModelTreeListFromStore({
                        currentPage: 1,
                        pageSize: 500,
                        state: 1,
                        modelType: 0,
                        appId: this.appId
                    });
                    this.dataTable = modelTree;
                } else {
                    let modelTree = await getApplicationModelTreeList({
                        currentPage: 1,
                        pageSize: 500,
                        state: 1,
                        modelType: 0
                    });
                    this.dataTable = modelTree;
                }
                this.isShow = true;
                if (this.field.options.config.form.modelId) { // 初始化赋值
                    let selectedTree = [];
                    selectedTree.push(this.field.options.config.form.modelId);
                    setTimeout(() => {
                        this.$refs.treeSelect.initParam(selectedTree);// 初始化当前报表关联的业务模型
                    }, 0);
                }
                this._setDefaultFiles();
                this.isShow = true;
            },
            _setDefaultFiles () {
                let formId = this.field.options.config.form.formId;
                if (formId) {
                    this.getFormDetail(formId);
                }
            },
            configSearch () {
                this.searchLoadTimer = new Date().getTime();
                this.isShowSearchSetting = true;
            },
            async resetSearchConditon () {
                this.searchFieldList.length = 0;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
    
                let formConfig = await getFormConfig(this.field.options.config.form.formId);
                if (formConfig && formConfig.fieldsList) {
                    this.searchFieldList = cloneDeep(formConfig.fieldsList);
                    this.searchLoadTimer = new Date().getTime();
                }
                loading.close();
            },
            subSetField () {
                this.field.ext1 = JSON.stringify(this.searchFieldList);
                this.isShowSearchSetting = false;
            },
            async getFormDetail (formId) {
                if (this.channelFlag === 'CS') {
                    const { fieldsList } = await getFormConfigFromStore(formId);
                    this.fieldList = fieldsList;
                    this.searchFieldList = cloneDeep(this.fieldList);
                } else {
                    const { fieldsList } = await getFormConfig(formId);
                    if (fieldsList) {
                        this.fieldList = fieldsList;
                        this.searchFieldList = cloneDeep(this.fieldList);
                    }
                }
                if (this.fieldList && this.fieldList.length > 0) {
                    this.filtFields = [];
                    if (!isEmpty(this.field.ext1)) {
                        this.defFilt = JSON.parse(this.field.ext1);
                        if (this.field.ext1) {
                            this.searchFieldList = JSON.parse(this.field.ext1);
                        } else {
                            this.searchFieldList = cloneDeep(this.fieldList);
                        }
                    }
                    this.fieldList.forEach(field => {
                        if (field.type === 'select' || (field.type === 'category' && field.options.config.type === 'single')) {
                            let filtField = cloneDeep(field);
                            if (!this.defFilt.hasOwnProperty(filtField.id)) {
                                this.defFilt[filtField.id] = Object.assign({}, {
                                    conditionValue: '',
                                    conditionValueView: ''
                                }, cloneDeep(filtField));
                                this.defFilt[filtField.id].options = {};
                            }
                            this.filtFields.push(filtField);
                        }
                    });
                    this.$emit('initLimitData', this.fieldList);
                }
                if (this.field.options.ext2) {
                    let obj = JSON.parse(this.field.options.ext2);
                    if (obj.linkConfig) {
                        let cur = JSON.parse(obj.linkConfig);
                        if (cur.linkConfigState) {
                            this.linkConfigArr.push(cur);
                        } else {
                            this.showLinkConfig();
                        }
                    } else {
                        this.showLinkConfig();
                    }
                }
            },
            showLinkConfig () {
                let arr = [];
                for (let i = 0; i < this.fieldList.length; i++) {
                    let cur = this.fieldList[i];
                    if (cur.type === 'link') {
                        for (let j = 0; j < this.allFields.length; j++) {
                            let obj = cloneDeep(this.allFields[j]);
                            if (obj.type === 'link') {
                                if (cur.options.config.form.formId === obj.options.config.form.formId) {
                                    obj.refId = cur.id;
                                    obj.linkFieldObj = JSON.stringify(cur);
                                    obj.linkConfigState = false;
                                    arr.push(obj);
                                }
                            }
                        }
                    }
                }
                this.linkConfigArr = arr;
            },
            handelChangeForm (selectModel) {
                if (selectModel) {
                    if (selectModel.type !== 2) {
                        this.$message({message: '请选择表单模型节点', type: 'warning'});
                        return;
                    }
                    this.selectFields = [];
                    this.defFilt = [];
                    this.selectTableHeaderFields = [];
                    this.field.options.config.form.modelId = selectModel.id;
                    this.field.options.config.form.formId = selectModel.formId;
                    this.getFormDetail(selectModel.formId);
                }
            },
            handleChangeSelect (value) {
                this.filtFields.forEach(filter => {
                    this.$refs[filter.id][0].options.forEach(option => {
                        if (option.currentValue === value) {
                            this.defFilt[filter.id].conditionValue = value;
                            this.defFilt[filter.id].conditionValueView = option.currentLabel;
                        }
                    });
                });
                delete this.defFilt['undefined'];
                this.field.ext1 = JSON.stringify(this.defFilt);
                this.loadTimer = new Date().getTime();
            },
            handleClearSelect (filtField) {
                if (this.defFilt.hasOwnProperty(filtField.id)) {
                    this.defFilt[filtField.id].conditionValue = '';
                    this.defFilt[filtField.id].conditionValueView = '';
                    this.field.ext1 = JSON.stringify(this.defFilt);
                }
            },
            changeLinkConfig (obj) {
                let ext = this.field.options.ext2;
                let conObj = {};
                if (ext) {
                    conObj = JSON.parse(ext);
                }
                conObj.linkConfig = JSON.stringify(obj);
                this.field.options.ext2 = JSON.stringify(conObj);
            },
            getLinkPropConfig () {
                return this.fieldList;
            },
            changeSelectTableHeaderFields () {
                let cacheFieldValue = cloneDeep(this.field);
                this.field = cacheFieldValue;
                this.$emit('changeSelectTableHeaderFields', cacheFieldValue);
            }
        }
    };
</script>
<style lang="less">
    .linkFieldModel{
        .def-item{
            display: block;
            .def-label{
                border: 1px solid #F2F2F2;
                margin-bottom: 15px;
                height: 70px;
                width: 94%;
                margin-left: 2%;
                margin-top: 10px;
                .def-tit{
                    background: #F2F2F2;
                    border-bottom: 1px solid #F2F2F2;
                    padding-left: 15px;
                    overflow: hidden;
                    height: 30px;
                    line-height: 30px;
                }
                .el-form-item__label{
                    font-size:12px;
                }
                .def-select{
                    height: 38px;
                    line-height: 38px;
                    width: 100%;
                    .el-input__inner{
                        border: none;
                    }
                    .el-input{
                        height: 38px;
                        line-height: 38px;
                        width: 100%;
                    }
                }
            }
            .def-search{
                width:200px;
                margin-top: 10px;
            }
            .link-config{
                margin-top: 10px;
                .link-config-label{
                    font-size: 14px;
                    color: #606266;
                }
                .link-config-content{
                    font-size: 14px;
                    color: #606266;
                }
            }
        }
        .search-field-box{
            height: 100% !important;
            .el-tabs{
                height: 100% !important;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/FieldProps/FieldPropsLink.vue